import React from "react";
import { Sparkles, PartyPopper } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";

const PERKS = {
  intermediate: ["Book Intermediate classes", "Level-up your socials game"],
  advance: ["Book Advance classes", "One step away from Focus Group"],
  focus: ["Enrol in Focus Group terms", "Commit to the full 10-term journey"],
};

export default function LevelUpDialog({ open, label, level, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="levelup-dialog" className="bg-[#140F1E] border-[#D4AF37]/40 text-white max-w-xs text-center overflow-hidden">
        <div className="relative py-4">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(212,175,55,0.25),transparent_70%)]" />
          <div className="relative">
            <div className="mx-auto w-16 h-16 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center mb-4">
              <PartyPopper size={30} className="text-[#D4AF37]" />
            </div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] flex items-center justify-center gap-1.5"><Sparkles size={13} /> Level up</p>
            <h2 className="font-display text-2xl font-bold mt-2">🎉 You unlocked {label}!</h2>
            <p className="text-[#A19DB0] text-sm mt-2">You've completed your milestone — {label} classes are now open for booking.</p>
            {PERKS[level] && (
              <ul data-testid="levelup-perks" className="mt-4 text-left space-y-1.5">
                {PERKS[level].map((p) => <li key={p} className="flex gap-2 text-sm text-[#E8E4F0]"><Sparkles size={14} className="text-[#D4AF37] mt-0.5 shrink-0" /> {p}</li>)}
              </ul>
            )}
            <button onClick={onClose} data-testid="levelup-close" className="mt-6 w-full rounded-full bg-[#D4AF37] text-black font-semibold py-3 active:scale-[0.98] transition-transform">
              Let's dance
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
